export const getApiErrorMessage = (response, fallbackMessage) =>
  response?.data?.message ||
  response?.data?.error?.response?.data?.message ||
  response?.data?.error?.message ||
  fallbackMessage;
